import React from 'react'
import gql from 'graphql-tag'
import { Typography, withStyles } from '@material-ui/core'
import { Button, Loader, Table } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom';
import { withApollo } from '@apollo/react-hoc';
import { withGraphqlQuery } from '../../../../graphql/core/connectors'
import SimpleTable from '../../../../components/core/tables/SimpleTable'
import Cvss from '../../../../components/labels/Cvss'
import { toChmodStr } from '../../../../utils/format'
import BinaryAnalysis from '../../../../components/composite/BinaryAnalysis'
import { shortSha256 } from '../../../../utils/format'
import { hardeningAsListFromNode, showFeatureStatusIcon } from '../binary-hardening/utils'

let RunBinaryAnalysis = (props) => {
  const { binaryType, binaryId, submissionId } = props;
  const [running, setRunning] = React.useState(false);

  if (running) {
    return (
      <Button disabled compact style={{width: 200}}>
        <Loader inline active style={{marginRight: 10, marginTop: 0}}/>
        Running Binary Analysis
      </Button>
    )
  }

  return (
    <Button 
      color="blue" 
      style={{width: 200, marginTop: 0}}
      content='Run Binary Analysis'
      onClick={() => {
        if (running === false) {
          console.log('triggering binary analysis');
          setRunning(true)
          props.client.mutate({
            mutation: gql`
              mutation RunBinaryAnalysis($input: RunBinaryAnalysisInput) {
                RunBinaryAnalysis(input: $input)
              }
            `,
            variables: {
              input: {
                binaryId,
                binaryType,
                submissionId
              }
            }
          })
          .then(d => {
            console.log(d)
          })
          .catch(e => {
            console.log(e)
          })
        }
      }}
    />
  )
}

RunBinaryAnalysis = withApollo(RunBinaryAnalysis)

class ExecutableDisplay extends React.Component {

  render() {
    const submissionId = this.props.match.params.imageId;
    const executable = this.props.data;
    const { classes, client, startPolling } = this.props;
    const foundInType = executable.foundIn.node.__typename
    
    return (
      <div className={classes.root}>
        <Typography className={classes.title}>{executable.name}</Typography>
        <div>{executable.id}</div>
        <div>
        { (foundInType === 'File') ? (<SimpleTable 
            order={['Path', 'Type', 'Version', 'Date', 'SHA256', 'Size']}
            fields={{
              'Path': executable.foundIn.node.path,
              'Type': executable.foundIn.node.magic,
              'SHA256': shortSha256(executable.foundIn.node.sha256),
              'Size': `${executable.foundIn.node.size} bytes`,
              'UID': executable.foundIn.uid,
              'GID': executable.foundIn.gid,
              'Permissions': toChmodStr(executable.foundIn.mode),
              'Version': executable.version,
              'Date': executable.date
            }}
          />) : (<SimpleTable 
            order={['Type', 'Description']}
            fields={{
              'Type': foundInType,
              'Description': executable.foundIn.node.desc
            }}
          />)}  
        </div>
        
        <Typography className={classes.section}>Findings</Typography>
        { executable.associatedFindings.length === 0 ? <div>No findings for this executable have been identified.</div> : (
          <Table compact collapsing celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Title</Table.HeaderCell>
                <Table.HeaderCell style={{width: '50px', minWidth: '50px'}}>Severity</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
            { executable.associatedFindings.map(r => r.node).map((finding) => {
                return (
                  <Table.Row key={finding.id}>
                    <Table.Cell>{finding.title}</Table.Cell>
                    <Table.Cell><Cvss score={finding.scoreCvss} /></Table.Cell>
                  </Table.Row>
                )
            })}
            </Table.Body>
          </Table>
        )}

        <Typography className={classes.section}>Hardening</Typography>
        <div>
          <Table compact collapsing celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Feature</Table.HeaderCell>
                <Table.HeaderCell>Enabled</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { hardeningAsListFromNode(executable).map((feature) => {
                return (
                  <Table.Row key={feature.name}>
                    <Table.Cell>{feature.name}</Table.Cell>
                    <Table.Cell>
                      {showFeatureStatusIcon(feature.enabled)}
                    </Table.Cell>
                    <Table.Cell>{feature.description}</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
        </div>
        
        <Typography className={classes.section}>Dynamic Libraries</Typography>
        { (executable.dynamicLibs.length === 0) ? (<div>This executable does not load other dynamic libraries.</div>) : (
          <div>
            <div>This executable loads the following libraries dynamically.</div>
            <Table compact collapsing celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Library</Table.HeaderCell>
                  <Table.HeaderCell>Loaded As</Table.HeaderCell>
                  <Table.HeaderCell>Path</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
              {executable.dynamicLibs.map((lib) => {
                return (
                  <Table.Row key={lib.node.id}>
                    <Table.Cell>{lib.node.name}</Table.Cell>
                    <Table.Cell>{lib.loadName}</Table.Cell>
                    <Table.Cell>{(lib.node.foundIn.node.path === undefined) ? lib.node.foundIn.node.path : lib.node.foundIn.node.name}</Table.Cell>
                  </Table.Row>
                )
              })}
              </Table.Body>
            </Table>
          </div>
        )}
        
        <Typography className={classes.section}>Static Libraries</Typography>
        { (executable.staticLibs.length === 0) ? (<div>This executable does not have statically linked components within it.</div>) : (
          <div>
            <div>This library contains the following statically linked components.</div>
            <Table compact collapsing celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Library</Table.HeaderCell>
                  <Table.HeaderCell>Path</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
              {executable.staticLibs.map((lib) => {
                return (
                  <Table.Row key={lib.node.id}>
                    <Table.Cell>{lib.node.name}</Table.Cell>
                    <Table.Cell>{(lib.node.foundIn.node.path === undefined) ? lib.node.foundIn.node.path : lib.node.foundIn.node.name}</Table.Cell>
                  </Table.Row>
                )
              })}
              </Table.Body>
            </Table>
          </div>
        )}

        <Typography className={classes.section}>Advanced Actions</Typography>
        { (executable.location.filter(r => (r.type === 'BNDB')).length > 0) ? (
          <React.Fragment>
            <BinaryAnalysis
              key={executable.id}
              executable={executable}
              client={client}
              startPolling={startPolling}
              binaryType='Executable'
            />
          </React.Fragment>) : (
            <RunBinaryAnalysis key={executable.id} binaryType='Executable' binaryId={executable.id} submissionId={submissionId} />
          ) }

      </div>
    )
  }
}

ExecutableDisplay = withRouter(ExecutableDisplay)

// style
ExecutableDisplay = withStyles((theme) => ({
  root: {
    display: 'flex', 
    flexDirection: 'column', 
    paddingTop: '20px',
    paddingLeft: '20px', 
    paddingRight: '20px',
    paddingBottom: '50px',
    height: 'calc(100%)',
    marginBottom: '50px',
  },
  title: {
    fontSize: 26,
    fontWeight: 800,
    marginBottom: '10px'
  },
  section: {
    fontSize: 20,
    fontWeight: 500,
    marginTop: 20,
    marginBottom: 10
  },
}))(ExecutableDisplay)

// data
ExecutableDisplay = withGraphqlQuery({
  query: gql`
    query Executable($input: ExecutableMatchInput) {
      Executable(input: $input) {
        id
        name
        date
        version
        hardeningNx
        hardeningPic
        hardeningRelro
        hardeningCanary
        hardeningStripped
        location {
          id
          type
        }
        analysisTask {
          id
          node {
            id
            status
          }
        }
        foundIn {
          id
          node {
            __typename
            ... on File {
              id
              path
              magic
              size
              uid
              gid
              sha256
              mode
            }
            ... on ImageContents {
              id
              name
              desc
            }
            ... on BaremetalContents {
              id
              name
              desc
            }
            ... on Kernel {
              id
              name
              desc
            }
          }
        }
        staticLibs {
          node {
            id
            name
            foundIn {
              id
              node {
                __typename
                ... on File {
                  id
                  path
                }
                ... on ImageContents {
                  id
                  name
                }
                ... on BaremetalContents {
                  id
                  name
                }
                ... on Kernel {
                  id
                  name
                }
              }
            }
          }
        }
        dynamicLibs {
          id
          loadName
          node {
            id
            name
            foundIn {
              id
              node {
                __typename
                ... on File {
                  id
                  path
                }
                ... on ImageContents {
                  id
                  name
                }
                ... on BaremetalContents {
                  id
                  name
                }
                ... on Kernel {
                  id
                  name
                }
              }
            }
          }
        }
        associatedFindings {
          id
          node {
            ... on FindingGeneric {
              id
              title
              scoreCvss
            }
            ... on FindingVulnerableVersion {
              id
              title
              scoreCvss
            }
            ... on FindingCryptographicKey {
              id
              title
              scoreCvss
            }
            ... on FindingVulnerableFunctionCall {
              id
              title
              scoreCvss
            }
          }
        }
      }
    } 
  `,
  variables: (props) => ({
    input: {id: props.executableId}
  }),
  onData: (data) => data.Executable[0],
  pollInterval: 30000,
})(ExecutableDisplay)

export default ExecutableDisplay
